import type { Product } from "../../../api/generated/model";

/** A product card's picture, as the Products page's: the first product shot, else the first image,
 *  its 512 px thumbnail first (spec teams/product-thumbs). */
export function coverOf(product: Product): { full: string; thumb: string | null } | null {
  const lead = product.images.find((image) => image.tag === "product_shot") ?? product.images[0];
  return lead?.url == null ? null : { full: lead.url, thumb: lead.thumb_url ?? null };
}
